import { Modal } from "bootstrap";
import { draggableBootstrapModal } from "../components/common/modal/draggable-modal";
import { NavigateFunction } from 'react-router-dom';
import { PROMPT_TYPE } from "../constants/prompt.constants";
import { PromptWorkflow } from "../interfaces/asset-execution.interface";
// START-CodeLeap [04-Sep-2026]: [#18188866946 PR-2615 review fixes] typed translation rows for
// getTranslatedTextOrFallback (getTranslatedText's own `any[]` param is pre-existing)
import { PageTranslationItem } from "../interfaces/common/common.interface";
// /END-CodeLeap [04-Sep-2026]: [#18188866946 PR-2615 review fixes]

//const markdownit = require('markdown-it');

type PageSetting = {
  USERPAGESETTINGID: number;
  PAGESETTINGDATE: string;
  PAGESETTINGKEY: string;
  PAGESETTINGVALUE: string;
};

export const ProcessingMessageKeyValues = [
  'processingMsg1.message',
  'processingMsg2.message',
  'processingMsg3.message'
];

// // Whitelist opening tags for API HTML responses (avoids markdown autolinks like <user@example.com>)
// const HTML_CONTENT_PATTERN = /^\s*<(!DOCTYPE\s|html|body|div|p|table|ul|ol|li|dl|dt|dd|h[1-6]|span|section|article|aside|nav|header|footer|main|pre|blockquote|thead|tbody|tfoot|tr|td|th|caption|colgroup|col|figure|figcaption|strong|em|b|i|u|a|br|hr|img|svg|iframe|video|audio|code|sub|sup|small|mark|center|font)\b/i;

// const isHtmlContent = (content: string): boolean => {
//   const trimmed = content.trim();
//   return trimmed.length > 0 && HTML_CONTENT_PATTERN.test(trimmed);
// };

export const convertMarkdownToHtml = (markdown: any, rootClass: any) => {
  return markdown;
  // if (markdown == null || markdown === '') {
  //   return '';
  // }

  // const content = typeof markdown === 'string' ? markdown : String(markdown);
  // if (isHtmlContent(content)) {
  //   return content;
  // }

  // var md = markdownit();
  // var htmlContent = md.render(markdown);

  // var textSizeClass = '';
  // switch (rootClass) {
  //   case 'stdTextS':
  //     textSizeClass = 'stdTextS';
  //     break;
  //   case 'stdText':
  //     textSizeClass = 'stdText';
  //     break;
  //   case 'stdTextL':
  //     textSizeClass = 'stdTextL';
  //     break;
  //   case 'stdTextXL':
  //     textSizeClass = 'stdTextXL';
  //     break;
  //   default:
  //     textSizeClass = 'stdText';
  // }

  // // Replace <strong> tags with Bootstrap classes
  // htmlContent = htmlContent.replace(/<strong>(.*?)<\/strong>/g, '<strong class="font-weight-bold">$1</strong>');

  // // Apply root class to <p> and <li> elements
  // htmlContent = htmlContent.replace(/<p>/g, `<p class="${textSizeClass}">`);
  // htmlContent = htmlContent.replace(/<li>/g, `<li class="${textSizeClass}">`);

  // // Add "markdownTableBLC" class to all <table> elements
  // htmlContent = htmlContent.replace(/<table/g, `<table class="markdownTableBLC table ${textSizeClass}"`);

  // // Apply root class to <th> elements within <table>
  // htmlContent = htmlContent.replace(/<th>/g, `<th class="${textSizeClass}">`);

  // // Apply root class to <td> elements within <table>
  // htmlContent = htmlContent.replace(/<td>/g, `<td class="${textSizeClass}">`);

  // // Remove escaped HTML tags
  // htmlContent = htmlContent.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');

  // // Remove escaped HTML tags and specified tags
  // htmlContent = htmlContent.replace(/&lt;pre id=&quot;markdownTableBLC&quot;&gt;/g, '').replace(/&lt;\/pre&gt;/g, '');
  // htmlContent = htmlContent.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
  // return htmlContent;
}


export const toggleCaptchaBadge = (show: boolean) => {
  const badge = document.getElementsByClassName('grecaptcha-badge')[0];
  if (badge && badge instanceof HTMLElement) {
    badge.style.visibility = show ? 'visible' : 'hidden';
  }
};


export const getLocalDateTime = (): string => {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const local = new Date(now.getTime() - offset * 60000);
  return local.toISOString().slice(0, 16);
}

export const FormatDate = (currentDate: any) => {
  currentDate = new Date(currentDate);
  // Get the month name
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const monthName = monthNames[currentDate.getMonth()];

  // Get the day and year
  const day = currentDate.getDate();
  const year = currentDate.getFullYear();

  // Format the date string
  const formattedDate = `${monthName}, ${day}/${year}`;

  // Display the formatted date
  return formattedDate
}

// Please keep in mind that if we change the url of the page in the future, we need to do extensive search and 
// change all the occurrences.
export const getPageByURL = (url: string): string | undefined => {
  const pages: { [key: string]: string } = {
    // Public pages (App.tsx)
    '/login/': 'login',
    '/forgotpwd/': 'forgotPassword',
    '/home/': 'home',
    '/app/askgpt/': 'askgpt', //it is for embed prompt
    '/app/exchangeHome/': 'exchangeHome',
    //'/app/exchangeList/': 'exchangeList',
    '/app/embed/library/': 'embedLibrary',
    '/referral/': 'referral',
    // For the time being, there is no separate page for company vanity page, so mapping it to 'libraries'
    '/company/': 'libraries',
    '/unsubscribe/': 'unsubscribe',
    //'/cardBlue/': 'blueCard',
    '/': 'vanityPage',

    // Secure pages (secure.tsx)
    '/app/promptStudio': 'dtd',
    '/app/promptStudio/:id': 'dtd',
    '/app/prompts/version/': 'promptVersionHistory',
    '/app/prompts/result/': 'promptResultsHistory',
    '/app/prompts/approval/': 'promptManager',
    '/app/userProfileEdit/': 'userProfile',
    '/app/accounting/': 'accounting',
    '/app/corpLibrary/': 'corpLibraryHome',
    /* START-CodeLeap [02-Jul-2026]: [1.2-personal library route→page mapping] */
    '/app/personalLibrary/': 'personalLibraryHome',
    /* /END-CodeLeap [02-Jul-2026]: [1.2-personal library route→page mapping] */
    //'/app/corpLibraryList/': 'corpLibraryList',
    '/app/orgCoinManagement/': 'organizationCoinManagement',
    '/app/payout/': 'payout',
    '/app/changePwd/': 'changePassword',
    '/app/manageTeam/': 'teamManagement',
    '/app/manageCorp/': 'corpManagement',
    '/app/manageOrg/': 'organizationManagement',
    '/app/requestCompany/': 'requestCompany',
    '/app/manageCustomModel/': 'manageCustomModel',
    //'/app/customModel/': 'customModel',//Not used
    '/app/chatMode/': 'chatMode',
    '/app/admin/approveAccRequest/': 'approveAccount',
    //'/app/internalAdminPortal/': 'InternalAdminHome',
    '/app/manageLibrary/': 'libraryManagement',
    '/app/myFeedback/': 'myFeedback',
    '/app/myMessages/': 'myMessages',
    '/app/myBadges/': 'myBadges',
    '/app/myPreferences/': 'userPreferences',
    '/app/admin/manageRoles/': 'adminRoleRights',
    '/app/admin/manageSegments/': 'adminSegments',
    '/app/manageMailServer/': 'manageMailServer',
    '/app/admin/adminBadges/': 'adminBadges',
    '/app/admin/manageTranslation/': 'adminTranslation',
    '/app/admin/translationList/': 'adminTranslationList',
    '/app/admin/adminLibraryApproval/': 'adminExchange',
    '/app/admin/adminPayoutApproval/': 'adminPayout',
    '/app/managePartner/': 'managePartner',
    '/app/manageCompany/': 'manageCompany',
    'app/partnerRequest/': 'partnerRequest',
    '/app/partnerHome/': 'partnerHome',
    //'/app/partnerProgramsList/': 'partnerProgramList',
    '/app/myNetwork/': 'myNetwork',
    '/app/agentStudio/': 'agentStudio',
    '/app/agentStudio/:id': 'agentStudio',
    // '/app/assetIo/': 'assetIo',
    '/app/agentExecution/': 'assetIo',
    '/app/agentExecution/:id': 'assetIo',
    '/app/solutionStudio/': 'solutionStudio',
    '/app/solutionStudio/:id': 'solutionStudio',
    '/app/solutionIo/': 'solutionIo',
    '/app/launchpad/': 'blueCallomLaunchpad',
    '/app/manageDBConnection/': 'manageDBConnection',
    '/app/manageDBQueryFunction/': 'manageDBQueryFunction',
    '/app/admin/adminAccTransSummary/': 'adminAccTransSummary',
    '/app/workspace': 'workspace',
    '/app/manageFunction' : 'manageFunction',
    '/app/actionDeck' : 'actionDeck',
    '/app/overviewAnalytics' : 'overviewAnalytics', 
    '/app/usageAnalytics' : 'usageAnalytics', 
    '/app/productivityAnalytics' : 'productivityAnalytics',
    '/app/consumptionAnalytics' : 'consumptionAnalytics',
    '/app/admin/salesOps' : 'salesOps',
    '/app/agentStudio/version' : 'agentStudioVersionHistory',
    '/app/solutionStudio/version': 'solutionStudioVersionHistory',
    '/app/admin/manageLLMModels' : 'manageLLMModels',
    '/app/admin/manageCurrency': 'manageCurrency',
    '/app/flight': 'blueCallomLaunchpad',
    '/app/application': 'blueCallomLaunchpad',
    '/app/flightDirector': 'flightDirector',
    '/app/admin/assignCoins': 'assignCoins',
    '/app/admin/adminManageUsers': 'adminManageUsers',
    '/app/admin/adminMessages': 'adminMessages',
    '/app/admin/adminUpgradeRequest': 'adminUpgradeRequest',
    '/app/admin/manageFeedback': 'ManageUserFeedback',
    '/app/corpSnetAPI': 'corpSnetAPI',
    '/app/qrCodeScanner': 'qrCodeScanner',
    '/app/manageEvents': 'manageEvents',
    '/eventLogin/': 'eventLogin',
    '/app/events/eventRegistration': 'eventRegistration',
    '/app/events/registeredEvents': 'registeredEvents',
    '/app/purchaseConfirmation': 'purchaseConfirmation',
    '/app/autoRecharge': 'orgPreferences',
    '/app/admin/assetExecutionReport': 'assetExecutionReport',
    '/app/mailboxConfig': 'mailboxConfig',
    '/app/BlueCallom' : 'blueCallom',
    '/app/teams' : 'teams',
    '/app/libraries': 'libraries',
    '/app/actionSpace': 'actionSpace',
    '/app/systemMgmt': 'systemMgmt',
    '/app/actionItems': 'actionItems',
    '/app/promptExecution': 'assetIo',
    '/app/actionItemHistory': 'blueCallomLaunchpad',
    '/app/admin/consumptionAccounting': 'consumptionAccounting',
    '/app/admin/companyManagement': "adminCompanyManagement",
    '/app/flightPlans': 'blueCallomLaunchpad',
    '/app/flightDeckOld': 'blueCallomLaunchpad',
    '/app/flightReport': 'blueCallomLaunchpad',
    '/app/flightDocument': 'blueCallomLaunchpad',
    '/app/documents/corporate': 'corpDocuments',
    '/app/flightAnalytics': 'blueCallomLaunchpad',
    '/app/admin/rewards': 'rewards',
    '/app/admin/userActivity': 'userActivity',
  };

/*
  // Ensure the URL has a trailing slash
  if (!url.endsWith('/')) {
    url += '/';
  }
  
  for (let key in pages) {
    if (url.includes(key)) {
      return pages[key];
    }
  }

  //function will only return a value if the URL exactly matches one of the keys in the pages object
  // for (let key in pages) {
  //   if (url === key) {
  //     return pages[key];
  //   }
  // }
*/

// Normalize the URL by removing query parameters and hash fragments
const normalizedUrl = url.split(/[?#]/)[0];

// Ensure the URL has a trailing slash
const urlWithTrailingSlash = normalizedUrl.endsWith('/')
  ? normalizedUrl
  : normalizedUrl + '/';

// Sort keys by length in descending order to prioritize specific matches
const sortedKeys = Object.keys(pages).sort((a, b) => b.length - a.length);

// Find the first matching key
for (let key of sortedKeys) {
  if (urlWithTrailingSlash.toLowerCase().includes(key.toLowerCase())) {
    return pages[key];
  }
}

return undefined; // Return undefined if no match is found
  
}

export const capitalizeFirstLetter = (string:string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const convertToThousands = (x: number | string) => {
  if(!x) return '0'
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const initializeModal = (id: string, clearErrors?: () => void, reset?: () => void, resetModalValues?: () => void) => {
  const modalElement = document.getElementById(id);
  if (modalElement) {
    draggableBootstrapModal(modalElement);

    const handleModalHidden = () => {
      if (reset){
        reset();
      }
      if (clearErrors){
        clearErrors();
      }
      if (resetModalValues) {
        resetModalValues();
      }
    };

    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }
};

export const hideModal = (id: string) => {
  const myModalEl = document.getElementById(id);
  if (myModalEl) {
    const modal = Modal.getOrCreateInstance(myModalEl);
    if (modal) {
      modal?.hide();
    }
  }
};

export const showModal = (id: string) => {
  const myModalEl = document.getElementById(id);
  if (!myModalEl) return;
  const modal = Modal.getOrCreateInstance(myModalEl);
  modal.show();
};

// Function to get the translated text from the translation key
export const getTranslatedText = (translationKey: string, PageTranslation: any[], contentFormat: string = 'plain'): string => {
  if (!Array.isArray(PageTranslation)) {
    //return `${translationKey}`;
    return '';
  }
 
  for (const item of PageTranslation) {
    // if (item.translationKey === translationKey) {
    //   return item.translation[0].TRANSLATEDTEXT;
    // }
    if (item.translationKey === translationKey) {
      let translatedText = item.translation[0].TRANSLATEDTEXT;
      // Tables require HTML structure; never flatten them even if format is mislabeled plain.
      const containsHtmlTable = /<table[\s>]/i.test(translatedText ?? '');
      //if (contentFormat === 'plain') {
      if (item.translationContentFormat === 'plain' && !containsHtmlTable) {
        // Remove <p> tags from the translated text
        //translatedText = translatedText.replace(/<p>/g, '').replace(/<\/p>/g, '');
        // Remove all HTML tags from the translated text
        translatedText = translatedText.replace(/<\/?[^>]+(>|$)/g, '');
      } 
      else if (item.translationContentFormat === 'html' || containsHtmlTable) {
        // Add class to <p> tags in the translated text
        translatedText = translatedText.replace(/<p>/g, '<p class="mb-0">');
      }
      return translatedText;
    }

  }
  return `${translationKey}`;
};

// START-CodeLeap [04-Sep-2026]: [#18188866946 PR-2615 review fixes]
/**
 * Resolve a translation key, falling back to a caller-supplied default when it cannot be resolved.
 *
 * getTranslatedText has two "no translation" outcomes and neither is safe to show a user: it
 * returns '' when PageTranslation is not an array (the payload has not loaded yet) and echoes the
 * key back when the key is not seeded. Anything rendering the result verbatim — <Alert>, a toast,
 * middleware — would then display an empty box or a key-shaped string.
 *
 * Lives here, next to getTranslatedText, so the guard has one home instead of being re-derived at
 * each call site. resolveSessionExpiredMessage below is the same idea hardcoded to one key; it is
 * left alone because its callers hand it already-resolved text rather than a key.
 *
 * Params : translationKey (string), PageTranslation (PageTranslationItem[]), fallback (string)
 * Returns: string - the translated text, or `fallback` when it cannot be resolved
 */
export const getTranslatedTextOrFallback = (
  translationKey: string,
  PageTranslation: PageTranslationItem[],
  fallback: string,
): string => {
  const translatedText = getTranslatedText(translationKey, PageTranslation);
  return !translatedText || translatedText === translationKey ? fallback : translatedText;
};
// /END-CodeLeap [04-Sep-2026]: [#18188866946 PR-2615 review fixes]

export const resolveSessionExpiredMessage = (translatedMsg: string | undefined): string => {
  return (translatedMsg === 'sessionExpired.message' || !translatedMsg)
    ? 'Your session has expired. Please log in again.'
    : translatedMsg;
};

// START-CodeLeap [11-Sep-2026]: [1.3-Fall back to the server message when a translation key is unseeded]
/**
 * getTranslatedText echoes the key back when it is not in the loaded list, so an unseeded key
 * reaches the user as "someKey.message". Prefer the translation; fall back to what the server
 * actually said rather than showing a raw key.
 */
export const getTranslatedTextOrDefault = (
  translationKey: string,
  PageTranslation: unknown[],
  fallback?: string,
): string => {
  const translated = getTranslatedText(translationKey, PageTranslation);
  const isUnresolved = translated === '' || translated === translationKey;
  return isUnresolved && fallback ? fallback : (translated || translationKey);
};
// /END-CodeLeap [11-Sep-2026]: [1.3-Fall back to the server message when a translation key is unseeded]

// Function to get the remaining characters
export const getRemainingCharacters = (maxLength: number, currentLength: number): number => {
  return Math.max(0, maxLength - currentLength);
};

// Function to navigate to the manage translation page
export const navigateToTranslation = (navigate: NavigateFunction, passedTranslationKey: string) => {
  navigate('/app/admin/manageTranslation', { state: { passedTranslationKey } });
};

//function to get the page setting value
export const getPageSettingValue = (settings: PageSetting[], key: string): string | undefined => {
  const setting = settings.find(setting => setting.PAGESETTINGKEY === key);
  return setting ? setting.PAGESETTINGVALUE : undefined;
};

//function to get popover content
export const generatePopoverContent = (notifications: { NOTIFICATION: string, REDIRECTURL: string, OBJTYPE: string, NOTIFICATIONAGE: string, OBJID: number }[]): string => {
  return `
    <div class="d-flex justify-content-between align-items-center mb-3" style="padding-right: 5px;">
      <div>Notifications</div>
      <button id="popover-close-btn" type="button" aria-label="Close" style="padding: 0; border: none; background: none; font-size: 1.5rem; line-height: 1; cursor: pointer; color: #000;">×</button>
    </div>
    <div class="notification-popover-container" style="max-height: 60vh; overflow-y: auto; overflow-x: hidden;">
      ${notifications && notifications.map(notification => `
        <div class="d-flex justify-content-between mb-2" style="padding-right: 8px;">
          <div style="flex: 1;">
            <a class="text-decoration-none" href="${notification.REDIRECTURL}${notification.REDIRECTURL.includes('?') ? '&' : '?'}objId=${notification.OBJID}">
              ${notification.NOTIFICATION}
            </a>
          </div>
          <div class="ms-3 text-nowrap" style="white-space: nowrap; margin-left: auto;">
            ${notification.NOTIFICATIONAGE}
          </div>
        </div>
      `).join('')}
    </div>
  `;
};
//function to get DNA value
export const extractDnaValue = (dnaString: string, position: number, length: number): string => {
  if(dnaString === undefined || dnaString?.length === 0) return '';
  // Ensure position is zero-based
  const zeroBasedPosition = position - 1;

  // Validate inputs
  // if (zeroBasedPosition < 0) {
  //   throw new Error('Position must be greater than 0');
  // }
  // if (length < 0) {
  //   throw new Error('Length must be non-negative');
  // }
  // if (zeroBasedPosition + length > dnaString.length) {
  //   throw new Error('Position and length exceed the dnaString length');
  // }

  // Extract the substring
  const extractedValue = dnaString.substring(zeroBasedPosition, zeroBasedPosition + length);
  return extractedValue;
};

const pattern = /@\[(.*?)\]\((\d+)\)/g;

// This function will take the input string and remove the ids if there are any and make the text appear as higlighted if there is an id corresponding to that text.
export const replaceMentions = (inputString: string, reverseMentionMap: Map<string, number>) => {
  if(inputString === undefined) {
    return '';
  }
  return inputString.replace(pattern, (match, displayName) => {
      // Check if reverseMentionMap has the displayName
      if (reverseMentionMap.has(displayName)) {
          const id = reverseMentionMap.get(displayName);
          if (id) {
              return `<span class="bc-highlighted-text" contenteditable="false">@${displayName}</span>`;
          }
      }
      return match; // Return the original match if no replacement is found
  });
};

// Function to get the first upper case character
export const getFirstUpperCaseChar = (inputString: string) => {
  if (inputString && inputString.length > 0) {
    return inputString.charAt(0).toUpperCase();
  }
  return inputString; 
}

export const validateEmails = (emailString:string) => {
  if(emailString?.length === 0) {
    return true;
  }
  // Trim the input string to ignore trailing commas and semicolons
  let trimmedInput = emailString?.trim();
  // Split the trimmed input string by comma or semicolon
  let emails = trimmedInput?.split(/[,;]\s*/);
  // Regex pattern for a single valid email
  let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // Check each email address
  for (let email of emails) {
    if (!emailPattern.test(email.trim())) {
        return false; // Return false if any email is invalid
    }
  }
  return true; // Return true if all emails are valid
};

export const truncateText = (text?: string, limit: number = 20) => (text?.length ?? 0) > limit ? `${text?.slice(0, limit)}...` : text ?? '';


export const isPromptsToConfigure = (agents: Array<any>): boolean => {
  if(agents.length === 0) return false;
  return agents.some(agent =>
    (agent?.agentWorkflow || []).some((prompt: PromptWorkflow) => {
      const type = extractDnaValue(prompt?.PROMPTDNA, 3, 1);
      return (
        prompt?.ALLOWAIRESPONSERECEIVER === 1 ||
        prompt?.PROMPTMULTIINPUT === 1 ||
        type === 'A' ||
        prompt?.PROMPTTYPEID === PROMPT_TYPE.SURVEY_PROMPT
      );
    })
  );
}

export const hexToRgb = (hex: string) => {
  const h = hex.replace("#", "").trim();
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

// START-CodeLeap [24-Aug-2026]: [#18188866946] byte-size formatter for upload chips/hints
export const formatSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
// /END-CodeLeap [24-Aug-2026]: [#18188866946]

// START-CodeLeap [14-Oct-2026]: [#18270529217 PR-2751 review] plain decimal digits only; Number() alone accepts "0x10", "1e2", " 7"
export const isNumeric = (value: unknown): boolean => /^\d+$/.test(String(value ?? ''));
// /END-CodeLeap [14-Oct-2026]: [#18270529217 PR-2751 review]
